import { type CanonicalEnvironment, normalizeEnvironment } from "../../shared/environment";
import type { JSTAppModelRecord, JSTEnvironment, Spec } from "../../tare-spec/NativeJSTAppModel";

/** Native codegen module is unavailable on web. */
export function getNativeJSTAppModelModule(): Spec | undefined {
  return undefined;
}

// The spec's `JSTEnvironment` mirrors the uppercase native values, while
// `normalizeEnvironment` collapses the host's raw stagingLevel to lowercase
// canonical values. Consumers re-normalize, so round-tripping here is lossless.
const SPEC_ENVIRONMENTS: Record<CanonicalEnvironment, JSTEnvironment> = {
  prod: "PROD",
  qa: "QA",
  e2eqa: "E2EQA",
};

function readJSTAppModel(): JSTAppModelRecord {
  return {
    appVersion: "web-1.0.0",
    buildConfig: "DEBUG",
    buildEnvironment: SPEC_ENVIRONMENTS[normalizeEnvironment(globalThis._tareData.stagingLevel)],
    locale: {
      languageCode: globalThis._tareData.languageCode,
      countryCode: globalThis._tareData.countryCode,
      // The host context carries no Indeed marketplace locale; consumers fall
      // back to languageCode/countryCode when these are absent.
      indeedLanguageCode: null,
      indeedCountryCode: null,
    },
  };
}

export function getJSTAppModel(): Promise<JSTAppModelRecord | null> {
  return Promise.resolve(getJSTAppModelSync());
}

export function getJSTAppModelSync(): JSTAppModelRecord | null {
  try {
    return readJSTAppModel();
  } catch (error: unknown) {
    console.error(error);
    return null;
  }
}
